document.addEventListener('DOMContentLoaded', function() {
  // ポップアップを開く
  const popupTriggers = document.querySelectorAll('[data-popup-target]');
  
  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const targetId = this.getAttribute('data-popup-target');
      const popup = document.getElementById(targetId);
      
      if (popup) {
        popup.classList.add('is-active');
        document.body.style.overflow = 'hidden'; // スクロール無効化
      }
    });
  });
  
  // ポップアップを閉じる
  const closePopup = (popup) => {
    popup.classList.remove('is-active');
    document.body.style.overflow = ''; // スクロール有効化
  };
  
  // 閉じるボタン
  const closeButtons = document.querySelectorAll('.c-popup__close');
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const popup = this.closest('.c-popup');
      closePopup(popup);
    });
  });
  
  // オーバーレイクリック
  const overlays = document.querySelectorAll('.c-popup__overlay');
  overlays.forEach(overlay => {
    overlay.addEventListener('click', function() {
      const popup = this.closest('.c-popup');
      closePopup(popup);
    });
  });
  
  // ESCキーで閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activePopup = document.querySelector('.c-popup.is-active');
      if (activePopup) {
        closePopup(activePopup);
      }
    }
  });
});